import { impersonate } from '@adornis/users/client/impersonation.js';
import { useEffect, useState } from 'react';
import { getAllTeachersQuery } from '../../../db/api/get-all-teachers.js';
import type { Teacher } from '../../../db/teacher.js';

export default function AdminPage() {
  const [teachers, setTeachers] = useState<Teacher[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [impersonatingId, setImpersonatingId] = useState<string | null>(null);

  useEffect(() => {
    let mounted = true;
    void getAllTeachersQuery()({
      _id: 1,
      firstName: 1,
      lastName: 1,
      email: 1,
      school: 1,
      userID: 1,
    }).then((result: Teacher[]) => {
      if (mounted) {
        setTeachers(result ?? []);
        setLoading(false);
      }
    }).catch((err: any) => {
      if (mounted) {
        setError(err?.message ?? 'Fehler beim Laden der Nutzer');
        setLoading(false);
      }
    });
    return () => { mounted = false; };
  }, []);

  const handleImpersonate = async (teacher: Teacher) => {
    setImpersonatingId(teacher._id as string);
    try {
      await impersonate(teacher.userID);
      window.location.href = '/';
    } catch (err: any) {
      setImpersonatingId(null);
      alert(`Impersonation fehlgeschlagen: ${err?.message ?? 'Unbekannter Fehler'}`);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 p-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-2xl font-bold text-slate-900 mb-6">Admin — Nutzerverwaltung</h1>

        {loading && (
          <p className="text-slate-500">Lade Nutzer…</p>
        )}

        {error && (
          <div className="bg-red-50 border border-red-200 text-red-700 rounded-lg p-4 mb-4">
            {error}
          </div>
        )}

        {!loading && !error && teachers.length === 0 && (
          <p className="text-slate-500">Keine Nutzer gefunden.</p>
        )}

        {!loading && teachers.length > 0 && (
          <div className="bg-white rounded-xl border border-slate-200 divide-y divide-slate-100 shadow-sm">
            {teachers.map(teacher => (
              <div key={teacher._id as string} className="flex items-center justify-between px-6 py-4 hover:bg-slate-50 transition-colors">
                <div>
                  <p className="font-medium text-slate-800">
                    {teacher.firstName} {teacher.lastName}
                  </p>
                  <p className="text-sm text-slate-500">{teacher.email}</p>
                  {teacher.school && (
                    <p className="text-xs text-slate-400">{teacher.school}</p>
                  )}
                </div>
                <button
                  type="button"
                  onClick={() => handleImpersonate(teacher)}
                  disabled={impersonatingId === (teacher._id as string)}
                  className="ml-4 px-4 py-2 bg-[#5594CF] text-white text-sm font-semibold rounded-lg hover:bg-[#4480B8] disabled:opacity-60 transition-colors"
                >
                  {impersonatingId === (teacher._id as string) ? 'Wird gestartet…' : 'Impersonieren'}
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
